<template lang="pug">
  div
    order-processing-top(:company="company")
    order-kanban-filters-chip(:company="company" :parentStatusOrder.sync="statusOrder")
    v-container.pa-0(style="max-width: 600px")
      div
        v-divider.basic300
        div.py-3.px-4.d-flex.align-center.mb-1
          bulk-order-actions(v-if="status === 1" :leads="readyLeads" :title="$t('ready')")
          bulk-order-actions(v-else :leads="processingLeads" :title="$t('processing')")
          v-spacer(v-if="selectedLeads.length == 0")
          .tabs(data-v-step='TourOrderKanbanView-1' v-if="selectedLeads.length == 0")
            v-btn(icon small color="transparent" @click="status = 0"  height="10")
              div(:style="`width: 24px; height: 6px; border-radius: 4px; background-color: ${status === 0 ? $vuetify.theme.themes[$theme].info400 : $vuetify.theme.themes[$theme].basic400}`")
            v-btn.ml-1(icon small color="transparent" @click="status = 1" height="10")
              div(:style="`width: 24px; height: 6px; border-radius: 4px; background-color: ${status === 1 ? $vuetify.theme.themes[$theme].info400 : $vuetify.theme.themes[$theme].basic400}`")
      .content-layout
        v-window.mx-4.mb-4(v-model="status")
          v-window-item
            kanban-processing(v-if="status === 0" ref="processing" :company="company" :menu="menu" :statusOrder="statusOrder" :parentLeads="processingLeads" @update="processingLeads = $event")
          v-window-item
            kanban-ready(v-if="status === 1" ref="ready" :company="company" :menu="menu" :statusOrder="statusOrder" :parentLeads="readyLeads" @update="readyLeads = $event")
      div.d-flex.mb-4
        v-spacer
        v-btn(icon small color="transparent" @click="status = 0")
          div(:style="`width: 24px; height: 6px; border-radius: 4px; background-color: ${status === 0 ? $vuetify.theme.themes[$theme].info400 : $vuetify.theme.themes[$theme].basic400}`")
        v-btn.ml-1(icon small color="transparent" @click="status = 1")
          div(:style="`width: 24px; height: 6px; border-radius: 4px; background-color: ${status === 1 ? $vuetify.theme.themes[$theme].info400 : $vuetify.theme.themes[$theme].basic400}`")
        v-spacer
</template>

<script>
import { mapGetters } from 'vuex'
import OrderProcessingTop from '@/components/ordermgmt/OrderProcessingTop.vue'
import OrderItem from '@/components/ordermgmt/OrderItem.vue'
import OrderKanbanFiltersChip from '@/components/ordermgmt/OrderKanbanFiltersChip.vue'
import KanbanProcessing from '@/components/ordermgmt/KanbanProcessing.vue'
import KanbanReady from '@/components/ordermgmt/KanbanReady.vue'
import BulkOrderActions from '@/components/ordermgmt/BulkOrderActions'

export default {
  name: 'OrderKanbanView',
  components: { OrderProcessingTop, OrderItem, OrderKanbanFiltersChip, KanbanProcessing, KanbanReady, BulkOrderActions },
  props: ['company', 'menu'],
  data: () => ({
    status: 0,
    checkAll: null,
    statusOrder: null,
    processingLeads: [],
    readyLeads: []
  }),
  computed: {
    ...mapGetters({
      selectedLeads: 'orders/getSelectedLeads',
      orderTempData: 'tours/getOrderTempData'
    }),
  },
  watch: {
  },
  mounted () {
    this.fullscreen = window.innerWidth < 600
    setTimeout(() => {
      this.orderTourCheck()
    }, 2000)
  },
  methods: {
    orderTourCheck () {
      if (this.orderTempData && ( this.orderTempData.value === 'completed' || (this.orderTempData.extra_data && this.orderTempData.extra_data.kanbanView))) {
        return
      }
      this.$store.commit('tours/setOrderManagementKanbanViewTour')
      this.$nextTick(() => {
        this.$tours['YezzaTour'].start()
      })
    },
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.v-sheet--outlined {
  border: thin solid var(--v-basic300) !important;
}
</style>